import { useTranslation } from 'react-i18next';
/**
 * Provides translations for the `common-form-ui` namespace using react-i18next.
 *
 * This hook ensures that components can access localized strings.
 *
 * @returns {UseTranslationResponse<'common-form-ui', undefined>} -
 * A translation response tuple including the translation function `t`,
 * the i18n instance, and the ready flag.
 */
export function useCommonFormUiTranslation() {
    return useTranslation('common-form-ui');
}
